// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.MocaPrompt-module__watchLink___XPNhK {
  display: inline-flex;
  align-items: center;
  gap: 6px;
  padding: 4px 10px;
  font-size: 13px;
  font-weight: 500;
  color: #3f3f46;
  background: #ffffff;
  border: 1px solid #d4d4d8;
  border-radius: 6px;
  text-decoration: none;
}

.MocaPrompt-module__watchLink___XPNhK:hover {
  border-color: #a1a1aa;
}

.MocaPrompt-module__noteBox___P1igS {
  display: flex;
  flex-direction: column;
  gap: 6px;
  width: 100%;
}

.MocaPrompt-module__noteInput___tEs0m {
  width: 100%;
  padding: 8px 10px;
  font-family: inherit;
  font-size: 14px;
  line-height: 1.5;
  color: #18181b;
  background: #ffffff;
  border: 1px solid #e4e4e7;
  border-radius: 6px;
  outline: none;
  resize: none;
}

.MocaPrompt-module__noteInput___tEs0m:focus {
  border-color: #a1a1aa;
}

.MocaPrompt-module__noteInput___tEs0m::placeholder {
  color: #a1a1aa;
}

.MocaPrompt-module__noteActions___fAn8w {
  display: flex;
  gap: 6px;
}

.MocaPrompt-module__noteButton___ffuMw {
  padding: 4px 10px;
  font-family: inherit;
  font-size: 13px;
  font-weight: 600;
  color: #fafafa;
  background: #18181b;
  border: none;
  border-radius: 6px;
  cursor: pointer;
}

.MocaPrompt-module__noteButton___ffuMw:hover:not(:disabled) {
  background: #27272a;
}

.MocaPrompt-module__noteButton___ffuMw:disabled {
  color: #a1a1aa;
  background: #e4e4e7;
  cursor: default;
}

.MocaPrompt-module__ghostButton___lDXm2 {
  padding: 4px 10px;
  font-family: inherit;
  font-size: 13px;
  font-weight: 500;
  color: #71717a;
  background: #ffffff;
  border: 1px solid #e4e4e7;
  border-radius: 5px;
  cursor: pointer;
}

.MocaPrompt-module__ghostButton___lDXm2:hover:not(:disabled) {
  color: #3f3f46;
  border-color: #a1a1aa;
}

.MocaPrompt-module__ghostButton___lDXm2:disabled {
  opacity: 0.5;
  cursor: default;
}

.MocaPrompt-module__decision___wI84R {
  padding: 12px 20px;
}

.MocaPrompt-module__insteadRow___mr2FU {
  display: flex;
  flex-wrap: wrap;
  align-items: center;
  gap: 8px;
}

.MocaPrompt-module__answerLine___lAG2n {
  display: flex;
  flex-wrap: wrap;
  align-items: center;
  gap: 8px;
}

.MocaPrompt-module__lockedBlock___AmABA {
  display: flex;
  flex-direction: column;
  gap: 4px;
  font-size: 13px;
}
.MocaPrompt-module__lockedBlock___AmABA p {
  margin: 0;
}

.MocaPrompt-module__lockedLine___ytwyp {
  color: #3f3f46;
}

.MocaPrompt-module__lockedFinal____ftqt {
  color: #71717a;
}

.MocaPrompt-module__reasonRow___eMIlF {
  display: flex;
  flex-wrap: wrap;
  align-items: center;
  gap: 6px;
  width: 100%;
}

.MocaPrompt-module__reasonInput___n7vha {
  flex: 1;
  min-width: 0;
  padding: 6px 10px;
  font-family: inherit;
  font-size: 14px;
  color: #18181b;
  background: #ffffff;
  border: 1px solid #e4e4e7;
  border-radius: 6px;
  outline: none;
}

.MocaPrompt-module__reasonInput___n7vha:focus {
  border-color: #a1a1aa;
}

.MocaPrompt-module__reasonInput___n7vha::placeholder {
  color: #a1a1aa;
}`, "",{"version":3,"sources":["webpack://./src/pages/CareOrchestration/components/MocaPrompt/MocaPrompt.module.scss"],"names":[],"mappings":"AAAA;EACE,oBAAA;EACA,mBAAA;EACA,QAAA;EACA,iBAAA;EACA,eAAA;EACA,gBAAA;EACA,cAAA;EACA,mBAAA;EACA,yBAAA;EACA,kBAAA;EACA,qBAAA;AACF;;AAEA;EACE,qBAAA;AACF;;AAEA;EACE,aAAA;EACA,sBAAA;EACA,QAAA;EACA,WAAA;AACF;;AAEA;EACE,WAAA;EACA,iBAAA;EACA,oBAAA;EACA,eAAA;EACA,gBAAA;EACA,cAAA;EACA,mBAAA;EACA,yBAAA;EACA,kBAAA;EACA,aAAA;EACA,YAAA;AACF;;AAEA;EACE,qBAAA;AACF;;AAEA;EACE,cAAA;AACF;;AAEA;EACE,aAAA;EACA,QAAA;AACF;;AAEA;EACE,iBAAA;EACA,oBAAA;EACA,eAAA;EACA,gBAAA;EACA,cAAA;EACA,mBAAA;EACA,YAAA;EACA,kBAAA;EACA,eAAA;AACF;;AAEA;EACE,mBAAA;AACF;;AAEA;EACE,cAAA;EACA,mBAAA;EACA,eAAA;AACF;;AAEA;EACE,iBAAA;EACA,oBAAA;EACA,eAAA;EACA,gBAAA;EACA,cAAA;EACA,mBAAA;EACA,yBAAA;EACA,kBAAA;EACA,eAAA;AACF;;AAEA;EACE,cAAA;EACA,qBAAA;AACF;;AAEA;EACE,YAAA;EACA,eAAA;AACF;;AAEA;EACE,kBAAA;AACF;;AAEA;EACE,aAAA;EACA,eAAA;EACA,mBAAA;EACA,QAAA;AACF;;AAEA;EACE,aAAA;EACA,eAAA;EACA,mBAAA;EACA,QAAA;AACF;;AAEA;EACE,aAAA;EACA,sBAAA;EACA,QAAA;EACA,eAAA;AACF;AACE;EACE,SAAA;AACJ;;AAGA;EACE,cAAA;AAAF;;AAGA;EACE,cAAA;AAAF;;AAGA;EACE,aAAA;EACA,eAAA;EACA,mBAAA;EACA,QAAA;EACA,WAAA;AAAF;;AAGA;EACE,OAAA;EACA,YAAA;EACA,iBAAA;EACA,oBAAA;EACA,eAAA;EACA,cAAA;EACA,mBAAA;EACA,yBAAA;EACA,kBAAA;EACA,aAAA;AAAF;;AAGA;EACE,qBAAA;AAAF;;AAGA;EACE,cAAA;AAAF","sourcesContent":[".watchLink {\n  display: inline-flex;\n  align-items: center;\n  gap: 6px;\n  padding: 4px 10px;\n  font-size: 13px;\n  font-weight: 500;\n  color: #3f3f46;\n  background: #ffffff;\n  border: 1px solid #d4d4d8;\n  border-radius: 6px;\n  text-decoration: none;\n}\n\n.watchLink:hover {\n  border-color: #a1a1aa;\n}\n\n.noteBox {\n  display: flex;\n  flex-direction: column;\n  gap: 6px;\n  width: 100%;\n}\n\n.noteInput {\n  width: 100%;\n  padding: 8px 10px;\n  font-family: inherit;\n  font-size: 14px;\n  line-height: 1.5;\n  color: #18181b;\n  background: #ffffff;\n  border: 1px solid #e4e4e7;\n  border-radius: 6px;\n  outline: none;\n  resize: none;\n}\n\n.noteInput:focus {\n  border-color: #a1a1aa;\n}\n\n.noteInput::placeholder {\n  color: #a1a1aa;\n}\n\n.noteActions {\n  display: flex;\n  gap: 6px;\n}\n\n.noteButton {\n  padding: 4px 10px;\n  font-family: inherit;\n  font-size: 13px;\n  font-weight: 600;\n  color: #fafafa;\n  background: #18181b;\n  border: none;\n  border-radius: 6px;\n  cursor: pointer;\n}\n\n.noteButton:hover:not(:disabled) {\n  background: #27272a;\n}\n\n.noteButton:disabled {\n  color: #a1a1aa;\n  background: #e4e4e7;\n  cursor: default;\n}\n\n.ghostButton {\n  padding: 4px 10px;\n  font-family: inherit;\n  font-size: 13px;\n  font-weight: 500;\n  color: #71717a;\n  background: #ffffff;\n  border: 1px solid #e4e4e7;\n  border-radius: 5px;\n  cursor: pointer;\n}\n\n.ghostButton:hover:not(:disabled) {\n  color: #3f3f46;\n  border-color: #a1a1aa;\n}\n\n.ghostButton:disabled {\n  opacity: 0.5;\n  cursor: default;\n}\n\n.decision {\n  padding: 12px 20px;\n}\n\n.insteadRow {\n  display: flex;\n  flex-wrap: wrap;\n  align-items: center;\n  gap: 8px;\n}\n\n.answerLine {\n  display: flex;\n  flex-wrap: wrap;\n  align-items: center;\n  gap: 8px;\n}\n\n.lockedBlock {\n  display: flex;\n  flex-direction: column;\n  gap: 4px;\n  font-size: 13px;\n\n  p {\n    margin: 0;\n  }\n}\n\n.lockedLine {\n  color: #3f3f46;\n}\n\n.lockedFinal {\n  color: #71717a;\n}\n\n.reasonRow {\n  display: flex;\n  flex-wrap: wrap;\n  align-items: center;\n  gap: 6px;\n  width: 100%;\n}\n\n.reasonInput {\n  flex: 1;\n  min-width: 0;\n  padding: 6px 10px;\n  font-family: inherit;\n  font-size: 14px;\n  color: #18181b;\n  background: #ffffff;\n  border: 1px solid #e4e4e7;\n  border-radius: 6px;\n  outline: none;\n}\n\n.reasonInput:focus {\n  border-color: #a1a1aa;\n}\n\n.reasonInput::placeholder {\n  color: #a1a1aa;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"watchLink": `MocaPrompt-module__watchLink___XPNhK`,
	"noteBox": `MocaPrompt-module__noteBox___P1igS`,
	"noteInput": `MocaPrompt-module__noteInput___tEs0m`,
	"noteActions": `MocaPrompt-module__noteActions___fAn8w`,
	"noteButton": `MocaPrompt-module__noteButton___ffuMw`,
	"ghostButton": `MocaPrompt-module__ghostButton___lDXm2`,
	"decision": `MocaPrompt-module__decision___wI84R`,
	"insteadRow": `MocaPrompt-module__insteadRow___mr2FU`,
	"answerLine": `MocaPrompt-module__answerLine___lAG2n`,
	"lockedBlock": `MocaPrompt-module__lockedBlock___AmABA`,
	"lockedLine": `MocaPrompt-module__lockedLine___ytwyp`,
	"lockedFinal": `MocaPrompt-module__lockedFinal____ftqt`,
	"reasonRow": `MocaPrompt-module__reasonRow___eMIlF`,
	"reasonInput": `MocaPrompt-module__reasonInput___n7vha`
};
module.exports = ___CSS_LOADER_EXPORT___;
